/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueCategoryDecisionResponse = {
    properties: {
        category: {
            type: 'LeagueCategoryEnum',
            isRequired: true,
        },
        main: {
            type: 'boolean',
            isRequired: true,
        },
        cup: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
